/* eslint-disable no-restricted-imports */
import {
  IconButton as IconButtonBase,
  type IconButtonProps,
} from "@src/appV2/redesign/system/ui-components";

/* eslint-enable no-restricted-imports */
import { ButtonInternalLink } from "./ButtonInternalLink";

export function IconButton(props: Omit<IconButtonProps, "LinkComponent">) {
  return <IconButtonBase {...props} LinkComponent={ButtonInternalLink} />;
}
